import React from "react";

export default class EPNHead extends React.Component {
  render() {
    return (
      <div className="epnhead">
        <img src={require("../img/head.png")} />
      </div>
    );
  }
}
EPNHead.defaultProps = {
  isFront: true
};



// WEBPACK FOOTER //
// ./src/components/head.js